<script>
export default {
    name: "AllocateDepositForm",
    data() {

return {
    filter: '',
   
    
};
},

    props: {

        mpesapayments: Array,
        mpesaAllocation: Object,
        totalReceive: Number,
    },
    // method:{
    //     filtermpesapayments() {
    //         let url = `Accounts/GetSpecificIPNPayments`;
    //             url += `?Allocated=0&SearchText=${this.filter}`;

    //         return this.$http.get(url).then(response => {
    //             this.mpesapayments = response.data;
               
    //         }).catch(() => {});
    //     },
    // },
}
</script>
<template>
    <div class="w-full flex flex-wrap">
     
         <div class="w-full overflow-auto"> 
            <table class="table">
                <thead class="bg-blue-500 text-xs text-white">
                    <tr class="w-full flex">
                        <th class="p-tiny flex-1">Date</th>
                        <th class="p-tiny flex-1">Payee</th>
                        <th class="p-tiny flex-1">Ref</th>
                        <th class="p-tiny flex-1">Account No</th>
                        <th class="p-tiny flex-1">Amount</th>
                        <th class="p-tiny flex-1">Unallocated</th>
                        <th class="p-tiny flex-1">Allocate</th>
                    </tr>
                </thead>
                <tbody class="text-xs bg-gray-100 flex flex-col items-center overflow-auto" style="height:20vh;">
                    <tr class="w-full flex" v-for="(patientMp, idx) in mpesapayments" :key="idx">
                        <td class="p-tiny flex-1">{{ patientMp.dateReceived | dateFormat}} </td>
                        <td class="p-tiny flex-1">{{ patientMp.customer_Name }}</td>
                        <td class="p-tiny flex-1">{{ patientMp.transaction_Reference }}</td>
                        <td class="p-tiny flex-1">{{ patientMp.transaction_BillNumber }}</td>
                        <td class="p-tiny flex-1">{{ patientMp.transaction_Amount | numberFormat }}</td>
                        <td class="p-tiny flex-1">{{ patientMp.remaining_Amount | numberFormat }}</td>
                        <!-- <td class="p-tiny flex-1">{{ patientDeposit.unAllocatedAmount | numberFormat }}</td> -->
                        <td class="p-tiny flex-1">
                            <label :for="`dep_${idx}`">
                                <input type="radio" 
                                    :disabled="patientMp.remaining_Amount < totalReceive ? true : false"
                                    :id="`dep_${idx}`"
                                    v-model="mpesaAllocation.allocations" 
                                    :value="{
                                        idx: idx,
                                        id: patientMp.id, 
                                        amount: totalReceive,
                                        receiptNo: patientMp.receiptNo,
                                        accountId:patientMp.accountID,
                                        paymentModeId:patientMp.paymentModeId,
                                        refNo:patientMp.transaction_Reference,
                                    }">
                                {{ totalReceive | numberFormat }}</label>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- <div class="md:w-2/3 sm:w-full p-tiny">
            <label for="grid-memo" class="label-control">Memo:</label>
            <input type="text" v-model.trim="depositAllocation.memo" id="grid-memo" class="input-control input-sm text-xs">
        </div> -->
    </div>
</template>